module.exports = __webpack_public_path__ + "img/icon-captcha-slider.0d9506d0.svg";